import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VNavigationDrawer, {
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: _vm.drawerWidth,
      temporary: ""
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c("div", {
    staticClass: "drawer"
  }, [_c("section", {
    staticClass: "drawer-header"
  }, [_c("div", {
    staticClass: "drawer-title"
  }, [_c(VBtn, {
    staticClass: "primary",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.close
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-close")])], 1), _c("h2", [_vm._v("Export stocks")])], 1)]), _c(VForm, [_c(VContainer, [_c(VRow, [_c(VCol, {
    attrs: {
      cols: "12"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.warehouses,
      "item-text": "name",
      "item-value": "id_warehouse",
      label: "Warehouses",
      loading: _vm.isLoadingWarehouses,
      "hide-details": "auto",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.form.warehouseIds,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "warehouseIds", $$v);
      },
      expression: "form.warehouseIds"
    }
  })], 1), _c(VCol, {
    attrs: {
      cols: "12"
    }
  }, [_c(VSelect, {
    attrs: {
      items: _vm.reservationOptions,
      "item-text": "name",
      "item-value": "id",
      label: "Reservation",
      "hide-details": "auto",
      clearable: ""
    },
    model: {
      value: _vm.form.reservationType,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "reservationType", $$v);
      },
      expression: "form.reservationType"
    }
  })], 1)], 1)], 1)], 1), _c(VBtn, {
    attrs: {
      color: "primary",
      loading: _vm.isExporting,
      disabled: !_vm.canExport
    },
    on: {
      click: _vm.exportStocks
    }
  }, [_vm._v(" Export ")])], 1), _c("ErrorModal", {
    ref: "dialogErrorModalRef"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };